import { EnvironmentContext, LanguageContext, TranslationsContext, useIsMobileHook } from '@telia-common-components/shared';
import { JsxRenderer } from '@telia-common-components/shared';
import React from 'react';
import { AnalyticsProvider, AnalyticsTrigger, Button, Card, CardBottom, CardContent, CardTop, EqualHeight, Grid, GridColumn, Heading, Icon, Modal, ModalProvider, Separator, } from 'telia-front-react';
import { Go3AppPacketInclusion } from './Go3AppPacketInclusion';
import { Go3AppPrice } from './Go3AppPrice';
import { Go3AppDetails } from './Go3AppDetails';
import { useGo3AppData } from './Go3AppDataProvider';
export const Go3AppCarouselCard = (props) => {
    var _a;
    const { tier } = React.useContext(EnvironmentContext);
    const { lang } = React.useContext(LanguageContext);
    const { translate } = React.useContext(TranslationsContext);
    const { go3App, productCode, tagText } = props;
    const { isMobile } = useIsMobileHook();
    const { teliaWebSelfServiceUrl, ensureLoginWithGotoUrl } = useGo3AppData();
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const tag = tagText ? { text: tagText } : null;
    const salesArguments = ((_a = go3App.appInfo) === null || _a === void 0 ? void 0 : _a.salesArguments.sections.map((section) => section.items).flat()) || [];
    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };
    const handleClick = () => {
        setIsModalOpen(false);
        ensureLoginWithGotoUrl(`${teliaWebSelfServiceUrl}/teenused/toote-valik?redirectUrl=L3RlbGxpbWluZS9saXNhdGVlbnVzdGUtdGVsbGltaW5lL29mZmVyaW5nP2Zsb3dOYW1lPXR2LWFwcHMmcHJvZHVjdD17cHJvZHVjdElkfSZwcm9kdWN0T2ZmZXJpbmdDb2RlPUdPM19BUFBfRklMTQ==&rootOnly=true&productCategoryCodes=TV_TEENUSED&productOfferingCode=${productCode}`);
    };
    return (React.createElement(Card, { padding: isMobile ? 'small' : 'medium', background: "brand-secondary-bg-subtle" },
        React.createElement(CardContent, { tagTop: tag || true },
            React.createElement(CardTop, null,
                React.createElement(EqualHeight, { group: "heading" },
                    React.createElement(Heading, { level: 2, className: "h3" }, translate(`go3App.title.${go3App.productOfferingCode}`)),
                    React.createElement(Separator, { color: "invisible", spacing: "xxsmall" })),
                React.createElement(EqualHeight, { group: "content" }, salesArguments.map((salesArgument, i) => (React.createElement(Grid, { key: i, horizontalGutter: "smedium", verticalGutter: "none", noWrap: true, gutter: "small" },
                    React.createElement(GridColumn, { width: ['min-xs'], align: ['middle-xs'] },
                        React.createElement(Icon, { modifiers: salesArgument.iconRef, size: "sm" })),
                    React.createElement(GridColumn, { width: ['max-xs'], align: ['middle-xs'] },
                        React.createElement(JsxRenderer, { jsx: salesArgument.text })))))),
                React.createElement(EqualHeight, { group: "inclusion" },
                    React.createElement(Separator, { spacing: "small", weight: "thin" }),
                    React.createElement(Go3AppPacketInclusion, { productCode: productCode })),
                React.createElement(EqualHeight, { group: "price" },
                    React.createElement(Go3AppPrice, { productCode: productCode, appPrice: go3App.price }))),
            React.createElement(CardBottom, null,
                React.createElement(AnalyticsTrigger, { trigger: {
                        id: ([isOpen]) => `Link - ${isOpen ? 'open' : 'close'} Modal Go3Details ${productCode}`,
                        callback: 'onToggle',
                    } },
                    React.createElement(ModalProvider, null,
                        React.createElement(AnalyticsTrigger, { trigger: {
                                id: `Link - open Modal Go3Details ${productCode}`,
                                callback: 'onClick',
                            } },
                            React.createElement(Button, { block: true, variant: "secondary", iconRight: "#arrow-right", text: translate('go3App.viewMore'), onClick: toggleModal })),
                        React.createElement(Modal, { isOpen: isModalOpen, onClose: toggleModal },
                            React.createElement(AnalyticsProvider, { group: "Modal" },
                                React.createElement(Go3AppDetails, { app: "public", language: lang, tier: tier, tagText: tagText, productCode: productCode, onCardSelect: handleClick }))))),
                React.createElement(Separator, { color: "invisible", spacing: "xsmall" }),
                React.createElement(AnalyticsTrigger, { trigger: { id: `CTA - ${productCode}`, callback: 'onClick' } },
                    React.createElement(Button, { block: true, type: "expressive", iconRight: "#arrow-right", onClick: handleClick, text: translate('go3App.cta') }))))));
};
